import React from "react";

const SubHeaderItem = ({ children, style }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: 10,
      flexWrap: "wrap",
      backgroundColor: "white",
      border: "1px solid rgb(235, 237, 240)",
      borderTop: "none",
      borderRadius: "0 0 6px 6px",
      padding: "8px 24px",
      marginBottom: 15,
      ...style,
    }}
  >
    {children}
  </div>
);

export default SubHeaderItem;
